import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { users } from "../../rbac-consts";
import { default as AdminProjectTabsContainer } from "./admin/ClientTabsContainer";

const ClientProjectWrapper = ({match}) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={users.ADMIN}
      yes={() => (
        <AdminProjectTabsContainer match={match} />
      )}
    />
  );
};

export default ClientProjectWrapper;